/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
class t{constructor(t,e,d){this.added=t,this.updated=e,this.removed=d}hasAnyUpdate(){return!!(this.added.length||this.updated.length||this.removed.length)}}export{t as GraphicUpdateMessage};
